import React from 'react';
import styled from 'styled-components';
import Typography from '../../common/typography/Typography';
import Icon from '../../common/icon/Icon';
import SearchBar from './SearchBar';
import useFetch from '../../../hooks/useFetch';
import { apiURL } from '../../../utils/axios';


const Container = styled.div`
  padding:10px;
  
  @media (min-width: 600px) {
 
    padding-left: 56px;
    padding-right: 56px;
  }
`;
const EventsContainer = styled.div`
  margin:20px 0; 
  display: grid;
  gap: 64px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr)); 
  }

  @media (min-width: 768px) {
    justify-content: space-between;
     grid-template-columns: repeat(auto-fill, minmax(400px, 1fr)); 
  }
`;

const CardContainer = styled.div`
  position: relative;

  height: 450px;
  background-image: url(${(props) => props.image});
  background-size: cover;
  background-position: center;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding:16px;
`;
const TopBadges = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  display: flex;
  justify-content: space-between;
  z-index: 1;
`;

const Badge = styled.div`
  background-color:#fff;
  padding: 8px 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap:5px;
  
`;

const BottomCard = styled.div`
  display:flex;
  flex-direction:column;
  gap:10px;
  background-color:#fff;
  padding: 12px;
  border-radius: 12px;
`;

const Title = styled.h3`
  margin: 0;
`;

const EventDescriptionItem = styled.div`
  display: flex;
  gap:15px;
`;
const EventDescriptionDetails = styled.div`
  display: flex;
  gap:5px;
`;
const EventDescriptionTitle = styled.div`
  display: flex;
  gap:5px;
`;
const IconWrapper = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  background-color:#5B63F61A;
  padding:8px;
  border-radius:8px;
`;
const DetailsWrapper = styled.div`
  display:flex;
  flex-direction:column;
  gap:5px;
  
`;








const Card = ({ image, location, city, address, discount, title, date, time }) => {
  return (
    <CardContainer image={image}>
      <TopBadges>
        <Badge>
          <Icon src="./static/icons/location.svg" width="20px" height="20px" />
          <Typography size="14px" weight="600"> {location}</Typography>
        </Badge>
        <Badge>
          <Icon src="./static/icons/ticket.svg" width="20px" height="20px" />
          <Typography size="14px" weight="600"> {discount}</Typography>
        </Badge>
      </TopBadges>
      <BottomCard>
        <Title> <Typography size="24px" weight="700"> {title}</Typography> </Title>
        <EventDescriptionItem>
          <IconWrapper>
            <Icon src="./static/icons/calendar_outlined.svg" width="20px" height="20px" />
          </IconWrapper>
          <DetailsWrapper>
            <EventDescriptionTitle>
              <Typography size="18px" weight="700"> {date}</Typography>
            </EventDescriptionTitle>

            <EventDescriptionDetails>
              <Typography size="14px" weight="500" color={"#A5A5AA"}> {time}</Typography>
            </EventDescriptionDetails>
          </DetailsWrapper>

        </EventDescriptionItem>
        <EventDescriptionItem>
          <IconWrapper>
            <Icon src="./static/icons/location_outlined.svg" width="20px" height="20px" />
          </IconWrapper>
          <DetailsWrapper>
            <EventDescriptionTitle>
              <Typography size="18px" weight="700"> {city}</Typography>
            </EventDescriptionTitle>

            <EventDescriptionDetails>
              <Typography size="14px" weight="500" color={"#A5A5AA"}> {address}</Typography>
            </EventDescriptionDetails>
          </DetailsWrapper>

        </EventDescriptionItem>

      </BottomCard>
    </CardContainer>
  );
};

function getTimezoneOffset(date) {
  const offset = new Date(date).getTimezoneOffset();
  const hoursOffset = Math.abs(offset / 60);
  const sign = offset <= 0 ? '+' : '-';
  return `GMT ${sign}${String(hoursOffset).padStart(2, '0')}:00`;
}
const eventsData = [
  {
    id: "1",
    image: "./static/event.png",
    location: "Algiers",
    city: "Preston Park",
    address: "8502 Preston Rd. Inglewood",
    discount: "Free Event",
    title: "Tennis session for beginners",
    date: "Monday, December 24, 2024",
    time: "18:00 - 23:30 (GMT +01:00)",
  },
  {
    id: "2",
    image: "./static/event.png",
    location: "Algiers",
    city: "Preston Park",
    address: "8502 Preston Rd. Inglewood",
    discount: "Free Event",
    title: "Tennis session for beginners",
    date: "Monday, December 24, 2024",
    time: "18:00 - 23:30 (GMT +01:00)",
  },
  {
    id: "3",
    image: "./static/event.png",
    location: "Algiers",
    city: "Preston Park",
    address: "8502 Preston Rd. Inglewood",
    discount: "Free Event",
    title: "Tennis session for beginners",
    date: "Monday, December 24, 2024",
    time: "18:00 - 23:30 (GMT +01:00)",
  },
  {
    id: "4",
    image: "./static/event.png",
    location: "Algiers",
    city: "Preston Park",
    address: "8502 Preston Rd. Inglewood",
    discount: "Free Event",
    title: "Tennis session for beginners",
    date: "Monday, December 24, 2024",
    time: "18:00 - 23:30 (GMT +01:00)",
  },
  {
    id: "5",
    image: "./static/event.png",
    location: "Algiers",
    city: "Preston Park",
    address: "8502 Preston Rd. Inglewood",
    discount: "Free Event",
    title: "Tennis session for beginners",
    date: "Monday, December 24, 2024",
    time: "18:00 - 23:30 (GMT +01:00)",
  },
  {
    id: "6",
    image: "./static/event.png",
    location: "Algiers",
    city: "Preston Park",
    address: "8502 Preston Rd. Inglewood",
    discount: "Free Event",
    title: "Tennis session for beginners",
    date: "Monday, December 24, 2024",
    time: "18:00 - 23:30 (GMT +01:00)",
  },

];


const Events = () => {
  const { data, loading, error } = useFetch('https://realverse.site/api/events?populate=true&own=false');
  let events = data?.data?.docs ?? []


  return (
    <Container>

      <SearchBar />
      <EventsContainer>
        {events.map((event, index) => (
          <Card
            key={event._id}
            image={event.poster?.url ? `${apiURL}/${event.poster.url}` : "./static/event.png"}
            location={event.venue?.name || "Unknown Venue"}
            city={event.venue?.city || "Unknown City"}
            address={event.venue?.address || "Unknown Address"}
            discount={event.basic_inventory_info?.has_free_ticket_classes ? "Free Event" : "Paid Event"}
            title={event.name}
            date={new Date(event.start.date).toLocaleDateString('en-US', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            time={`${new Date(event.start.date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })} - ${new Date(event.end.date).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })} (${getTimezoneOffset(event.start.date)})`}
          />
        ))}
        {(loading) && <p>Loading events...</p>}
        {(error) && <p>Error fetching events: {error}</p>}

      </EventsContainer>
    </Container>
  );
};

export default Events;